import { useGameContainer } from '../index';
import ContentSection, { ContentSectionFlushContent, ContentSectionHeader } from '@/components/ContentSection';
import styles from './styles/GameSeries.module.scss';
import WebScoreboardGame from '@/components/web/WebScoreboardGame';
import { COMPLETED } from 'constants/GameStatuses';

export default function GameSeries() {
  const [{ game }] = useGameContainer();

  const bracketSeries = game.contest?.bracketSeries;
  if (!bracketSeries) return null;

  const completedGames = bracketSeries.bracketSeriesContests
    .map(sc => ({ game: sc.primaryGame, pos: sc.seriesPosition }))
    .filter(({ game }) => game && game.statusId === COMPLETED);

  if (completedGames.length === 0) {
    return null;
  }

  return (
    <ContentSection>
      <ContentSectionHeader>Series Results</ContentSectionHeader>
      <ContentSectionFlushContent>
        <div className={styles.SeriesLeadText}>
          {bracketSeries.bestOfText}, {bracketSeries.seriesStatusText}
        </div>

        {completedGames.map(({ game, pos }) => (
          <div key={game?.id} className={styles.GameResult}>
            <WebScoreboardGame game={game!} showRecords={false} showState statusMessage={`game ${pos}`} hideHeader />
          </div>
        ))}
      </ContentSectionFlushContent>
    </ContentSection>
  );
}
